import { render, staticRenderFns } from "./knowledgeVideoList.vue?vue&type=template&id=c1f58744&scoped=true"
import script from "./knowledgeVideoList.vue?vue&type=script&lang=js"
export * from "./knowledgeVideoList.vue?vue&type=script&lang=js"
import style0 from "./knowledgeVideoList.vue?vue&type=style&index=0&id=c1f58744&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f58744",
  null
  
)

export default component.exports